import { render, staticRenderFns } from "./tercher.vue?vue&type=template&id=a67d7de2&"
import script from "./tercher.vue?vue&type=script&lang=js&"
export * from "./tercher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports